import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/Login";
import { AccountsPage, AccountDetailPage } from "@/pages/Accounts";
import UsersPage from "@/pages/Users";
import ProjectsPage from "@/pages/Projects";
import ProjectDetailPage from "@/pages/ProjectDetail";
import ContactListDetailPage from "@/pages/ContactListDetail";
import { CampaignsListPage, CampaignBuilderPage, CampaignDetailPage } from "@/pages/Campaigns";
import AuditPage from "@/pages/Audit";
import DashboardPage from "@/pages/Dashboard";
import MessagesPage from "@/pages/Messages";
import ScheduledPage from "@/pages/Scheduled";
import ApiKeysPage from "@/pages/ApiKeys";
import QuickSendPage from "@/pages/QuickSend";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/accounts" element={
                <ProtectedRoute adminOnly><AccountsPage /></ProtectedRoute>
              } />
              <Route path="/accounts/:id" element={
                <ProtectedRoute adminOnly><AccountDetailPage /></ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>
              } />
              <Route path="/audit" element={
                <ProtectedRoute adminOnly><AuditPage /></ProtectedRoute>
              } />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/projects/:id/campaigns" element={<CampaignsListPage />} />
              <Route path="/projects/:id/campaigns/new" element={<CampaignBuilderPage />} />
              <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
              <Route path="/contact-lists/:id" element={<ContactListDetailPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/quick-send" element={<QuickSendPage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route path="/projects/:id/scheduled" element={<ScheduledPage />} />
              <Route path="/accounts/:id/api-keys" element={<ProtectedRoute adminOnly><ApiKeysPage /></ProtectedRoute>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
